import { OvalLoader } from "@avenueops/web-components";
import { StarIcon as StarIconOutline } from "@heroicons/react/24/outline";
import { StarIcon as StarIconFilled } from "@heroicons/react/24/solid";
import { ProcessView } from "@prisma/client";
import { toast } from "react-toastify";
import { trpc } from "utils/trpc";

interface Props {
  signalView: ProcessView;
}

export function ProcessTableFavoriteViewToggle({ signalView }: Props): JSX.Element | null {
  const utils = trpc.useContext();
  const onToggleFavorite = async () => {
    await updateFavorite({ processViewId: signalView.id, favorite: !signalView.favorite });
  };

  const { mutateAsync: updateFavorite, isLoading: updateLoading } = trpc.processViews.favorite.useMutation({
    onSuccess: async () => {
      await utils.processViews.list.invalidate();
      await utils.processViews.get.invalidate({ processViewId: signalView.id! });
      toast.success("View was successfully updated!");
    },
  });
  return updateLoading ? (
    <div className="flex p-2 mr-2 items-center">
      <OvalLoader type="DEFAULT" size={14} />
    </div>
  ) : (
    <div className="hover:bg-cool-gray-200 rounded-lg p-2 mr-2" onClick={onToggleFavorite}>
      {signalView.favorite ? <StarIconFilled className="h-5 w-5 text-yellow-500" /> : <StarIconOutline className="h-5 w-5 text-gray-500" />}
    </div>
  );
}
